import { resourcePath } from '@gameday/utils/resource-path';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';
import { getSafeLanguagePath } from './languageHelpers';
const et = 'America/New_York';

export default ({ gamePk = '', date = '', mediaId }, tz, gameContext = '', language = 'en') => {
    if (!gamePk) {
        return '';
    }

    const params = {
        game_pk: gamePk,
        languagePath: getSafeLanguagePath(language),
        mediaIdPath: mediaId ? `/v${mediaId}` : ''
    };

    if (date) {
        const UTCDate = zonedTimeToUtc(date, tz); // convert to UTC first based on the given timezone
        params.date = format(utcToZonedTime(UTCDate, et), 'yyyyMMdd'); // convert to ET timezone
    }

    return resourcePath.get(`${gameContext}tvLink`, params) || resourcePath.get('tvLink', params); // default to mlb if not available
};
